import styled from '@emotion/styled'
import { Button, ButtonGroup, ButtonProps } from '@mui/material'

interface NavButtonProps extends ButtonProps {
    isActive?: boolean;
}

const NavButton = styled(Button)<NavButtonProps>(({ isActive = false }) => ({
    fontWeight: '400',
    
    display: 'flex',
    justifyContent: 'flex-start',
    color: 'var(--text-primary)',
    textTransform: 'none',
    outline: 'none',
    border: '3px solid transperant',
    boxSizing: 'border-box',
    "&.MuiButton-contained:hover": {
        background: '#1E91E033 !important',
        boxSizing: 'border-box',
        border: '3px solid #1E91E0 !important',
    },
    '&.active': {
        background: `radial-gradient(50% 50% at 50% 100%, #1E91E0 0%, 
        rgba(30, 145, 224, 0.435417) 40%, 
        rgba(20, 145, 224, 0) 90%)`
    }
}))

export const NavButtonGroup = styled(ButtonGroup)(({ theme }) => ({
    height: 56,
    display: 'flex',
    justifyContent: 'center',
    '&.MuiButtonGroup-root .MuiButtonBase-root': {
        borderRadius: '12px !important',
        transition: 'border 300ms ease-in-out, background 300ms ease-in-out'
    }
}))


export default NavButton;